// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"beo_a big_b big_va big_rv big_rw big_vu","PanelFooter--link":"beo_b"};